 
<!-- <mat-form-field class="matField" floatLabel="never"> -->
    <input class="w-100" id="google-search" matInput placeholder="Add location*" ngxAutocomPlace (selectedPlace)="placeChangedCallback($event)" [hideResultDropdown]="false" [formControl]="control" name="google-city-fetch" type="text" autocomplete="off" />
<!-- </mat-form-field>  -->
 